import { useState, useEffect } from 'react'
import { Button, Row, Col, Badge } from 'react-bootstrap'
import { Warning, CaretCircleLeft, CaretCircleRight, WhatsappLogo } from 'phosphor-react'
import { toast } from 'react-toastify'
import api from '../../../../services/api'
import { useNavigate } from 'react-router-dom'

import DeliveryMap from '../../../../components/Vehicle/Map/DeliveryMap'
import { openWindow } from '../../../../utils/whatsapp'
import styles from './styles.module.css'
import { useLoading } from '../../../../hooks/LoadingContext'

function VeiculoRotaDiaria({ requests, vehicleId, role }) {
  const [vehicleInfo, setVehicleInfo] = useState({})
  const [requestShowingIndex, setRequestShowingIndex] = useState(0)

  const handleChangeShowingIndex = (direction) => {
    if (direction === 'left' && requestShowingIndex > 0)
      setRequestShowingIndex(requestShowingIndex - 1)
    else if (direction === 'right' && requestShowingIndex < requests.length - 1)
      setRequestShowingIndex(requestShowingIndex + 1)
  }

  const navigate = useNavigate()
  const { setIsLoading } = useLoading()

  useEffect(() => {
    async function loadData() {
      try {
        setIsLoading(true)
        const { data } = await api.get(`/${role}/vehicles/${vehicleId}?driverInfo=1`)
        setVehicleInfo(data)
      } catch (err) {
        toast.error('Falha ao buscar os dados do veículo. Tente novamente mais tarde')
      }
      setIsLoading(false)
    }
    loadData()
  }, [vehicleId, role, setIsLoading])

  return (
    <div>
      <Row className="text-md-left mt-4">
        <Col>
          <Row>
            <h4>
              {`Entregas de hoje de ${vehicleInfo.board} | ${
                vehicleInfo.model
              } ${vehicleInfo.color} dirigido por ${vehicleInfo.driver_name || 'Desconhecido'}`}
            </h4>
          </Row>
          <Row className="text-center">
            {requests.length ? (
              <Row>
                <Row style={{ height: 400, width: '100%', marginLeft: 7 }}>
                  <DeliveryMap
                    className="col-10"
                    requestId={requests[requestShowingIndex].id}
                    role={role}
                  ></DeliveryMap>
                </Row>
                <Row className="d-flex" style={{ marginLeft: 8 }}>
                  <Col>
                    <Button
                      disabled={requestShowingIndex === 0}
                      className={styles.btnCaret}
                      onClick={() => handleChangeShowingIndex('left')}
                    >
                      <CaretCircleLeft color="#053C5E" size={25}></CaretCircleLeft>
                    </Button>
                  </Col>
                  <Col>
                    <p style={{ marginTop: 1 }}>{`${
                      requestShowingIndex + 1
                    } de ${requests.length}`}</p>
                  </Col>
                  <Col>
                    <Button
                      disabled={requestShowingIndex === requests.length - 1}
                      className={styles.btnCaret}
                      onClick={() => handleChangeShowingIndex('right')}
                    >
                      <CaretCircleRight color="#053C5E" size={25}></CaretCircleRight>
                    </Button>
                  </Col>
                </Row>
              </Row>
            ) : (
              <Badge bg="#053C5E" text="white" className={styles.noRequestsBadge}>
                <Warning style={{ marginBottom: 2 }} color="#ffffff" size={15} weight="bold" />{' '}
                Nenhuma entrega feita hoje!
              </Badge>
            )}
          </Row>
          <Row>
            {role === 'company' && (
              <Col className="col-12 col-md-6">
                <div className="text-center mt-3 mt-md-2 mb-3">
                  <Button
                    className={styles.btnVehicleInfo}
                    onClick={() => navigate(`/empresa/veiculos/info/${vehicleId}`)}
                  >
                    Ver todos os dados do veículo
                  </Button>
                </div>
              </Col>
            )}
            {role !== 'attendant' && (
              <Col className="col-12 col-md-6">
                <div className="text-center mt-md-2 mb-3">
                  <Button
                    className={styles.btnWhatsapp}
                    disabled={!vehicleInfo.driver_phone}
                    onClick={() => openWindow(vehicleInfo.driver_phone)}
                  >
                    <WhatsappLogo
                      style={{ marginRight: 3, marginTop: -3 }}
                      size={20}
                    ></WhatsappLogo>
                    Entrar em contato com o motorista
                  </Button>
                </div>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default VeiculoRotaDiaria
